import { render } from "./ValidateItems.vue?vue&type=template&id=31ff0124&scoped=true"
import script from "./ValidateItems.vue?vue&type=script&lang=js"
export * from "./ValidateItems.vue?vue&type=script&lang=js"

import "./ValidateItems.vue?vue&type=style&index=0&id=31ff0124&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ff0124"]])

export default __exports__